import Vue from "vue";
import Buefy from "buefy";

import B2BCheckout from "./App.vue"

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})


if (document.getElementById("b2bCheckoutApp")){
    new Vue({
        render:h=>h(B2BCheckout,{
            props:{
                productsUrl:document.getElementById("b2bCheckoutApp")
                    .getAttribute("products-url"),
                prodDetailUrl:document.getElementById("b2bCheckoutApp")
                    .getAttribute("prod-detail-url"),
                createCartItemUrl: document.getElementById("b2bCheckoutApp")
                    .getAttribute("create-cart-item"),
                cartDetailUrl:document.getElementById("b2bCheckoutApp")
                    .getAttribute("cart-detail-url"),
                cartItemDetailUrl: document.getElementById("b2bCheckoutApp")
                    .getAttribute("cart-item-detail-url"),
                noDataIll:document.getElementById("b2bCheckoutApp")
                    .getAttribute("no-data"),
                createOrder: document.getElementById("b2bCheckoutApp")
                    .getAttribute("create-order"),
                profileEndpoint: document.getElementById("b2bCheckoutApp")
                    .getAttribute("profile-endpoint"),
                userEmail: document.getElementById("b2bCheckoutApp")
                    .getAttribute("user-email"),
                userSettings: document.getElementById("b2bCheckoutApp")
                    .getAttribute("user-settings"),
                categoryListEndpoint: document.getElementById("b2bCheckoutApp")
                    .getAttribute("category-list-endpoint"),
                subcategoryListEndpoint: document.getElementById("b2bCheckoutApp")
                    .getAttribute("subcategory-list-endpoint"),
                notFound: document.getElementById("b2bCheckoutApp")
                    .getAttribute("not-found"),
            }
        })
    }).$mount("#b2bCheckoutApp")
}